import {Injectable} from 'ng-metadata/core';

@Injectable()
export class ChaptersResultsLineService {
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultsChaptersAndReviews/chaptersResultsLine.service.ts